import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { QuestComponent } from './quest/quest.component';
import { LoadingComponent } from './quest/loading/loading.component';
import { LeaderBoardComponent } from './leaderBoard/leader-board.component';
import { QuestItemComponent } from './quest/quest-item/quest-item.component';
import { InfoComponent } from './quest/info/info.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { WelcomeComponent } from './welcome/welcome.component';


const routes: Routes = [
  { path: 'loading', component: LoadingComponent },
  { path: 'quest', component: QuestComponent },
  { path: 'leaderboard', component: LeaderBoardComponent },
  { path: 'info', component: InfoComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'schedule', component: ScheduleComponent },
  { path: 'item/:itemid', component: QuestItemComponent},
  { path: '', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
